import React from "react";
import { Badge, Col, Row } from "antd";

interface Props {
  yearLevelsAccepted: number[];
}

const RelevantStudyYearsDisplay: React.FC<Props> = ({ yearLevelsAccepted }) => {
  return (
    <>
      <Col>
        <Row>
          {[1, 2, 3, 4, 5].map(yearLevel => (
            <Col style={{ padding: "0.1em" }} key={yearLevel}>
              <Badge
                count={yearLevel}
                style={{
                  backgroundColor: yearLevelsAccepted.includes(yearLevel)
                    ? "var(--bindeleddet-color)"
                    : "var(--neutral-alter)",
                  color: yearLevelsAccepted.includes(yearLevel) ? "var(--neutral)" : "var(--neutral-alt)",
                }}
              />
            </Col>
          ))}
        </Row>
      </Col>
    </>
  );
};

export default RelevantStudyYearsDisplay;
